"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchConfig = searchConfig;

function searchConfig(labelConfig, levels) {
  return levels.reduce(function (search, level) {
    return search[level];
  }, labelConfig);
}